import { css } from 'styled-components';
export const cubicEaseOut = `cubic-bezier(0.33, 1, 0.68, 1)`;
export const inViewMargin = '0px 0px -35% 0px';
export function fadeIn(animate, duration, delay, easingFunc) {
    return css `
    transition: opacity ${duration}ms ${delay}ms ${easingFunc};

    ${animate
        ? css `
          opacity: 1;
        `
        : css `
          opacity: 0;
        `}
  `;
}
export const shouldAnimate = (innerCss) => {
    return css `
    @media (prefers-reduced-motion: no-preference) {
      ${innerCss}
    }
  `;
};
export const transition = (properties, duration = 0.35, timing = cubicEaseOut) => {
    return shouldAnimate(css `
    transition: ${properties};
    transition-duration: ${typeof duration === 'string' ? duration : `${duration}s`};
    transition-timing-function: ${timing};
    will-change: ${properties};
  `);
};
